<template>
  <modal v-if="showEmailConfirmed">
    <template v-slot:header>
      <h5 class="modal-title" v-t="'dialogs.confirm-email.title'"></h5>
      <button class="close" aria-label="Close" @click.prevent="closeDialog">
        <span aria-hidden="true">
          <img src="@/assets/img/static/b-icon_close_x.svg" alt="">
        </span>
      </button>
    </template>

    <template v-slot:body>
      <div class="modal-body__registration">
        <p v-if="error">{{error}}</p>
        <p v-else v-t="'dialogs.confirm-email.body.success'"></p>
      </div>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--white-border gui-btn--ep"
              @click.prevent="closeDialog"
              v-t="'buttons.next'"></button>
    </template>
  </modal>
</template>

<script>
  import Errors from '@/api/types/errors'
  import Modal from '@/widgets/modal'

  export default {
    data: () => ({
      showEmailConfirmed: false,
      error: undefined
    }),

    components: {
      Modal
    },

    async created() {
      this.runAction(async () => {
        try {
          await this.$store.dispatch('confirmEmail', {
            code: this.$route.query.code,
            confirmId:  this.$route.query.confirmId
          });

          this.showEmailConfirmed = true
        }
        catch(e) {
          console.error('Unable to confirm email', e);

          this.globalErrorHandler(e, {
            'ALREADY_EXISTS': 'errors.email-already-in-use"'
          });

          this.showEmailConfirmed = true;
        }
      });
    },

    methods: {
      closeDialog() {
        this.showEmailConfirmed = false;
        this.$router.push({ name: 'home ' });
      }
    }
  }
</script>

<style scoped>

</style>
